import Vue from 'vue';
import notificationService from '@/services/notificationService';
import { Module } from 'vuex';
import repos from '@/services/listsRepository';

const catalogsModule: Module<any, any> = {
    namespaced: true,
    state: {
        lists: [],
        initialised: false,
        loading: true,
        saving: false,
    },
    getters: {
        lists: (state) => state.lists,
        list: (state) => (name: string) => state.lists.find((o: ICatalogList) => o.name === name),
        loading: (state) => state.loading,
    },
    mutations: {
        setItems(state, objects) {
            state.initialised = true;
            state.lists = objects;
        },
        updateItem(state, object) {
            const foundItem = state.lists.find((x: any) => x.id === object.id);
            if (foundItem) {
                Object.assign(foundItem, object);
            } else {
                state.lists.push(object);
            }
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setSaving(state, value) {
            state.saving = value;
        },
    },
    actions: {
        async fetch({ commit, dispatch, state }) {
            if (!state.initialised) {
                commit('setLoading', true);
                try {
                    const res = await repos.get();
                    commit('setItems', res.data);
                } catch (err) {
                    notificationService.failedToLoad();
                } finally {
                    commit('setLoading', false);
                }
            }
        },
        async setList({ commit, dispatch }, {name, value}) {
            // commit('setSaving', true);
            try {
                await repos.refreshValues(name, value);
                dispatch('load', name);
                notificationService.saved();
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                // commit('setSaving', false);
            }
            return true;
        },
        async load({ commit, dispatch }, name: string) {
            // commit('setLoading', true);
            try {
                const res = await repos.getSingle(name);
                commit('updateItem', res.data);
            } catch (err) {
                notificationService.failedToLoad();
                await dispatch('load');
            } finally {
                // commit('setLoading', false);
            }
        },
        async addValue({ commit, dispatch }, {name, value}) {
            // commit('setSaving', true);
            try {
                await repos.addValue(name, value);
                dispatch('load', name);
                notificationService.saved();
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                // commit('setSaving', false);
            }
            return true;
        },
        async removeValue({ commit, dispatch }, {name, value}) {
            commit('setSaving', true);
            try {
                await repos.removeValue(name, value);
                dispatch('load', name);
                notificationService.saved();
            } catch (err) {
                notificationService.failedToSave();
                return false;
            } finally {
                commit('setSaving', false);
            }
            return true;
        },
    },
};

export default catalogsModule;
